<template>
    <div>
        <br>
        <h3>Trainee Information</h3>
        <hr>
        <vue-form :state="formstate">
            <div class="row">
                <div class="col">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.medicalSpeciality)">
                        <label>Medical Speciality</label>
                        <input type="text" name="medicalSpeciality" class="form-control" required
                               v-model.lazy="state.registrantData.traineeExtraData.medicalSpecialty" tabindex="15">
                        <field-messages name="medicalSpecialty" show="$touched || $submitted" class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">This is a required field</div>
                        </field-messages>
                    </validate>
                    <validate auto-label class="form-group required-field"
                              :class="fieldClassName(formstate.traineeStatus)">
                        <label>What is your current trainee status?</label>

                        <select class="form-control" name="traineeStatus" required
                                v-model.lazy="state.registrantData.traineeExtraData.traineeType">
                            <option value="Student">Student</option>
                            <option value="Fellow">Fellow</option>
                            <option value="Resident">Resident</option>
                        </select>

                        <field-messages name="traineeStatus" show="$touched || $dirty || $submitted"
                                        class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">This is a required field</div>
                        </field-messages>
                    </validate>
                </div>
            </div>
            <br>
            <h3>Proof of Training Status*</h3>
            <hr>
            <div class="row">
                <div class="col">
                    <label class="custom-file">
                        <input type="file" id="file" class="custom-file-input" @change="onFileSelected" tabindex="16">
                        <span class="custom-file-control">{{state.registrantData.proof.name}}</span>
                    </label>
                </div>
            </div>
        </vue-form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'Trainees',
        data: function () {
            return {
                formstate: {},
            }
        },
        computed: {
            ...mapGetters({
                state: 'getState',
            }),

        },
        watch: {
            formstate: function (val) {
                this.state.formstate.trainee = val;
            },
        },
        methods: {
            onFileSelected: function (event) {
                this.$store.commit('addProof', event.target.files[0]);
            },
            fieldClassName: function (field) {

                if (!field) {
                    return ''
                }
                if ((field.$touched || field.$submitted) && field.$valid) {
                    return 'has-success'
                }
                if ((field.$touched || field.$submitted) && field.$invalid) {
                    return 'has-danger'
                }
            },
            onSubmit: function () {
                console.log(this.formstate.$valid)
            }
        },
    }
</script>

<style>
    .required-field > label::after {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
</style>
